import { Action, Field } from '@/components/general/list-view/types'
import { createFeatureList } from '../list'
import { Feature } from '@/pinia/feature'

const fields: Field[] = [
  {
    key: 'labels.externalId',
    type: 'text',
    showInViews: ['minimized', 'fullscreen'],
    localeString: {
      en: 'Key',
      sv: 'Nyckel'
    },
    sortDirection: 'asc'
  },
  {
    key: 'labels.externalLabel',
    type: 'text',
    showInViews: ['minimized', 'fullscreen'],
    localeString: {
      en: 'No.',
      sv: 'Nr'
    }
  },
  {
    key: 'labels.rentalObjectType',
    type: 'text',
    showInViews: ['minimized', 'fullscreen'],
    localeString: {
      en: 'Type',
      sv: 'Typ'
    }
  },
  {
    key: 'labels.rentalObjectSubType',
    type: 'text',
    localeString: {
      en: 'Subtype',
      sv: 'Undertyp'
    }
  },
  {
    key: 'labels.floor',
    type: 'text',
    showInViews: ['minimized', 'fullscreen'],
    localeString: {
      en: 'Floor',
      sv: 'Våning'
    }
  },
  {
    key: 'labels.area',
    type: 'number',
    format: {
      maximumFractionDigits: 1
    },
    showInViews: ['minimized', 'fullscreen'],
    localeString: {
      en: 'Area (m²)',
      sv: 'Area (m²)'
    }
  },
  {
    key: 'labels.vacant',
    type: 'text',
    localeString: {
      en: 'Vacant',
      sv: 'Vakant'
    }
  },
  {
    key: 'labels.accountedRent',
    type: 'number',
    format: {
      maximumFractionDigits: 0
    },
    localeString: {
      en: 'Acc. rent',
      sv: 'Deb. hyra'
    }
  },
  {
    key: 'labels.proposedMarketRent',
    type: 'number',
    format: {
      maximumFractionDigits: 0
    },
    localeString: {
      en: 'Proposed market rent',
      sv: 'Föreslagen marknadshyra'
    }
  },
  {
    key: 'labels.description',
    type: 'text',
    area: true,
    localeString: {
      en: 'Description',
      sv: 'Beskrivning'
    }
  },
  {
    key: 'mainPath',
    type: 'path',
    localeString: {
      en: 'Placement',
      sv: 'Placering'
    }
  },
  {
    key: 'createdDate',
    type: 'date',
    format: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    },
    localeString: {
      en: 'Created',
      sv: 'Skapades'
    }
  },
  {
    key: 'lastModifiedDate',
    type: 'date',
    format: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    },
    localeString: {
      en: 'Updated',
      sv: 'Uppdaterades'
    }
  }
]

const actions: Action[] = [
  {
    actionName: 'new',
    type: 'new',
    labelKey: 'general__text__new',
    icon: 'IconPlusSquareSmall',
    access: 'CREATOR'
  },
  {
    actionName: 'view',
    type: 'single',
    icon: 'IconFileSearch',
    labelKey: 'general__text__open',
    access: 'READER',
    hiddenInModal: true
  },
  {
    actionName: 'edit',
    type: 'single',
    icon: 'IconEditSmall',
    labelKey: 'general__text__change',
    access: 'EDITOR',
    replaces: ['view'],
    hiddenInModal: true
  },
  {
    actionName: 'delete',
    type: 'bulk',
    labelKey: 'general__text__delete',
    icon: 'IconTrash2Small',
    access: 'ADMIN'
  }
]

const rentalObjectList = {
  ...createFeatureList({
    type: 'RENTAL_OBJECT',
    icon: 'IconHomeWork',
    title: {
      en: 'Rental Objects',
      sv: 'Hyresobjekt'
    },
    fields,
    actions,
    listMaxActions: 1,
    mainPathFilter: true,
    categoryFilter: false
  }),
  component: 'RentalObjectDashboard'
}

export const rentalObjects: Feature = {
  name: 'rental-objects',
  enabled: false,
  title: {
    en: 'Rental Objects',
    sv: 'Hyresobjekt'
  },
  component: 'FeatureCard',
  isRoute: true,
  props: {
    icon: 'IconHomeWork',
    disableIsDrawPointActive: true,
    enableFullscreen: true
  },
  children: [
    {
      name: 'lists',
      enabled: true,
      title: {
        en: 'Rental Objects',
        sv: 'Hyresobjekt'
      },
      children: [rentalObjectList]
    }
  ]
}
